import { render, staticRenderFns } from "./AboutCards.vue?vue&type=template&id=2548eb2a&scoped=true"
import script from "./AboutCards.vue?vue&type=script&lang=js"
export * from "./AboutCards.vue?vue&type=script&lang=js"
import style0 from "./AboutCards.vue?vue&type=style&index=0&id=2548eb2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2548eb2a",
  null
  
)

export default component.exports